import React from "react";

const ModelSwitch = ({ value, onChange, options = [], compact = false }) => {
  return (
    <div
      className={[
        "inline-flex items-center rounded-2xl p-1",
        "bg-slate-100 dark:bg-slate-900/60",
        "ring-1 ring-slate-200 dark:ring-slate-800",
      ].join(" ")}
      role="tablist"
      aria-label="انتخاب مدل"
    >
      {options.map((opt) => {
        const active = opt.id === value;
        return (
          <button
            key={opt.id}
            type="button"
            onClick={() => onChange(opt.id)}
            className={[
              "rounded-2xl transition px-3 py-2 text-sm",
              compact ? "px-2.5 py-1.5 text-xs" : "",
              active
                ? "bg-white dark:bg-slate-950 text-slate-900 dark:text-white shadow-sm"
                : "text-slate-600 dark:text-slate-300 hover:bg-white/60 dark:hover:bg-slate-950/40",
            ].join(" ")}
            role="tab"
            aria-selected={active}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
};

export default ModelSwitch;
